import FinalResultItem from "./FinalResultItem";

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css'

import style from '../CSS/FinalResult.module.css';
import SliderItem from "../../RoundVideoResultFive/Component/SliderItem";

const FinalResult = ({data}) => {
    return (
        <>
            <div className={style.finalResult}>
                <div className={style.finalResult__header}>
                    <p>Top 10 Selected Participant</p>
                </div>
                <div>
                    <OwlCarousel className='owl-theme' items={3} autoplay loop nav>
                        {
                            data && data.length > 0 && data.map((item)=> (
                                <div className='item'>
                                    <FinalResultItem info={item}/>
                                </div>
                            ))
                        }
                    </OwlCarousel>
                </div>
            </div>
        </>
    );
};

export default FinalResult;